import React, { FC } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import palette from "../../../../../../styles/palette";

import { useDate } from "../../../../../../utility/useDate";

import { IFlightLookupItem } from "../../../../../../logic/api";
import { useTranslation } from "react-i18next";

interface FlightResultConfirmDialogProps {
  open: boolean,
  selectedFlight: IFlightLookupItem | null,
  onCancel: () => void,
  onConfirm: () => void,
}

const FlightResultConfirmDialog: FC<FlightResultConfirmDialogProps> = ({
  open,
  selectedFlight,
  onCancel,
  onConfirm,
}: FlightResultConfirmDialogProps) => {
  const { toFormattedDateString, toFormattedTimeString } = useDate();
  const { t } = useTranslation();

  if (!selectedFlight) {
    return null;
  }

  return <Dialog open={open}>
    <DialogTitle style={{ textAlign: "center" }}>{t("flightLookup.confirmFlightDetails")}</DialogTitle>

    <DialogContent>
      <DialogContentText style={{ textAlign: "center" }}>
        {t("flightLookup.checkFlightDetails")}
      </DialogContentText>

      <table style={{ width: "100%" }} cellPadding={5}>
        <tbody>
          <tr>
            <td colSpan={2} style={{ textAlign: "center" }}>
              <b><span style={{ color: palette.active.primary }}>{selectedFlight.transfer}</span> &gt; {selectedFlight.airport}</b>
            </td>
          </tr>
          <tr>
            <td style={{ width: "50%", textAlign: "right" }}>{t("flightLookup.labels.flight")}:</td>
            <td><b style={{ color: palette.active.primary }}>{selectedFlight.airline}{selectedFlight.flight_no}</b></td>
          </tr>
          <tr>
            <td style={{ width: "50%", textAlign: "right" }}>{t("flightLookup.labels.terminal")}:</td>
            <td><b style={{ color: palette.active.primary }}>{selectedFlight.terminal == null ? t("flightLookup.noTerminal") : selectedFlight.terminal || ""}</b></td>
          </tr>
          <tr>
            <td style={{ textAlign: "right" }}>{t("flightLookup.labels.date")}:</td>
            <td><b style={{ color: palette.active.primary }}>{toFormattedDateString(new Date(selectedFlight.relativeDateTime))}</b></td>
          </tr>
          <tr>
            <td style={{ textAlign: "right" }}>{t("flightLookup.labels.time")}:</td>
            <td><b style={{ color: palette.active.primary }}>{toFormattedTimeString(new Date(selectedFlight.relativeDateTime))}</b></td>
          </tr>
        </tbody>
      </table>
    </DialogContent>

    <DialogActions>
      <Button onClick={onCancel} color="primary">{t("general.cancel")}</Button>
      <Button onClick={onConfirm} color="primary">{t("general.confirm")}</Button>
    </DialogActions>
  </Dialog>
}

export default FlightResultConfirmDialog;
